<template>
  <BlBackdrop
    title="Credit limit exceeded"
    label="Proceed"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSubmit"
  >
    <div class="px-8 w-160">
      <div
        class="mb-4 w-full flex flex-col items-center gap-1 px-4 py-3 rounded bg-slate-200"
      >
        <BlTextBody3 text="Number of projected remaining credits:" />
        <div class="font-bold text-6xl text-dark-purple-100">
          {{ remainingCredits }}
        </div>
      </div>
      <div>
        <BlTextBody2
          text="The number of credits used for the appointment(s) will result in a deficit once the session(s) is completed. Do you still want to proceed with creating the appointment(s)?"
        />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import BlBackdrop from "../../BlBackdrop.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextBody3 from "../../BlTextBody3.vue";

export default {
  name: "CreditLimitExceededModal",
  components: {
    BlBackdrop,
    BlTextBody2,
    BlTextBody3
  },
  props: {
    remainingCredits: { type: Number }
  },
  methods: {
    onSubmit() {
      this.$emit("on-submit");
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/modal/CreditLimitExceededModal.vue